import {ApiProvider} from "@renta-apps/athenaeum-react-common";
import UserStrongAuthentication from "@/models/server/Responses/UserStrongAuthentication";

export const getUserStrongAuthenticationAsync = async (email: string): Promise<UserStrongAuthentication> => {
    return ApiProvider.getAsync<UserStrongAuthentication>(`/api/Admin/GetUserStrongAuthentication?email=${email}`, null);
};

export const removeUserStrongAuthenticationAsync = async (email: string): Promise<boolean> => {
    return ApiProvider.postAsync<boolean>("/api/Users/RemoveUserStrongAuthentication", email, null);
};